import * as React from 'react';

export default () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 7V17" stroke="#6C7280" strokeWidth="2" strokeLinecap="round" />
    <path d="M7 12L17 12" stroke="#6C7280" strokeWidth="2" strokeLinecap="round" />
  </svg>
);
